import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'hc-video',
    templateUrl: 'hc-video.html',
    providers: []
})
export class HcVideo {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('index') index: number;
    @Input('first') first: boolean;

    constructor(public element: ElementRef) {

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hc-video/hc-video.ts